import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";
import SEO from "../components/SEO";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "", first_name: "", last_name: "" });
  const [loading, setLoading] = useState(false);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form);
      toast.success("Účet vytvořen, vítejte!");
      navigate("/ucet");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Chyba registrace");
    } finally { setLoading(false); }
  };

  return (
    <div className="pt-10 pb-20 px-4 min-h-screen" data-testid="register-page">
      <SEO title="Registrace" noindex />
      <div className="max-w-md mx-auto">
        <div className="text-center mb-8">
          <h1 className="font-display text-3xl font-bold">Registrace</h1>
          <p className="text-zinc-600 mt-2 text-sm">Už máte účet? <Link to="/prihlaseni" className="text-blue-600 font-semibold">Přihlásit se</Link></p>
        </div>
        <form onSubmit={submit} className="bg-white rounded-2xl border border-zinc-200 p-7 space-y-4">
          <div className="grid grid-cols-2 gap-3">
            <Field label="Jméno" value={form.first_name} onChange={(v) => set("first_name", v)} testid="reg-firstname"/>
            <Field label="Příjmení" value={form.last_name} onChange={(v) => set("last_name", v)} testid="reg-lastname"/>
          </div>
          <Field label="E-mail" type="email" value={form.email} onChange={(v) => set("email", v)} required testid="reg-email"/>
          <Field label="Heslo (min. 8 znaků)" type="password" value={form.password} onChange={(v) => set("password", v)} required testid="reg-password"/>
          <button type="submit" disabled={loading} className="btn-primary w-full py-3 rounded-full font-semibold" data-testid="reg-submit">
            {loading ? "Vytvářím…" : "Vytvořit účet"}
          </button>
        </form>
      </div>
    </div>
  );
}

function Field({ label, value, onChange, type = "text", required, testid }) {
  return (
    <div>
      <label className="text-xs font-semibold text-zinc-600">{label}</label>
      <input value={value} onChange={(e) => onChange(e.target.value)} type={type} required={required} data-testid={testid}
        className="w-full mt-1 px-3 py-2.5 rounded-xl border border-zinc-200 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500"/>
    </div>
  );
}
